// extracted by mini-css-extract-plugin
module.exports = {"globalSubmitBtn":"TEUp1UJ_","cancel":"JUaiWFHK","globalSubmitBtnDisabled":"gccr_mq9"};